<ion-content class="modal-outher-container">
  <ion-grid class="modal-inner-container">
    <ion-row>
      <ion-col>
        <app-modal-header
          header="{{ 'SPACE_MAP.ASSIGN_SPACE' | translate }}"
          (close)="close()"
        >
        </app-modal-header>
        <ion-grid
          class="space-map-assign-space__list-container custom-scrollbar"
        >
          <ion-row>
            <ion-col size="12" size-sm="6">
              <app-search-bar (searchEvent)="onChangeSearch($event)">
              </app-search-bar>
            </ion-col>
            <ion-col size="12" size-sm="6">
              <ion-button
                (click)="toggleAssignedSpaces()"
                fill="outline"
                class="space-map-assign-space__toggle-assigned-button"
              >
                <ng-container *ngIf="!showAllSpaces">
                  {{ "SPACE_MAP.SHOW_ALL" | translate }}
                </ng-container>
                <ng-container *ngIf="showAllSpaces">
                  {{ "SPACE_MAP.SHOW_UNASSIGNED" | translate }}
                </ng-container>
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-grid
          class="space-map-assign-space__list-container custom-scrollbar"
        >
          <ion-row>
            <ion-col
              size="12"
              size-sm="6"
              *ngFor="let space of spaceListToShow"
            >
              <div
                (click)="markSpace(space)"
                class="space-map-assign-space__space"
                [ngClass]="{
                  'space-map-assign-space__space--marked':
                    space.id === selectedSpace?.id
                }"
              >
                <img
                  *ngIf="space.image"
                  class="space-map-assign-space__image"
                  (click)="onImagePreview($event, space.image.filePath)"
                  [src]="
                    space.image.thumbnail
                      ? space.image.thumbnail
                      : space.image.filePath
                  "
                />
                <img
                  *ngIf="!space.image"
                  class="space-map-assign-space__image space-map-assign-space__image--plug"
                  src="../../../assets/icons/parking-plug.svg"
                />
                <div>
                  {{ space.name }}
                  <img
                    class="light"
                    *ngIf="space.subType"
                    [src]="spaceServ.searchSubtypeIcon(space.subType)"
                  />
                </div>
                <div class="space-map-assign-space__assign-icon-container">
                  <ion-icon
                    class="space-map-assign-space__assign-icon"
                    *ngIf="space.posX && space.posY"
                    src="assets/icons/point.svg"
                  ></ion-icon>
                </div>
              </div>
            </ion-col>
            <ion-grid
              class="space-map-assign-space__list-container custom-scrollbar"
              *ngIf="spaceListToShow.length === 0"
            >
              <ion-row>
                <ion-col size="12">
                  <div>
                    {{ "SPACE_MAP.NO_PLACES" | translate }}
                  </div>
                </ion-col>
              </ion-row>
            </ion-grid>
          </ion-row>
        </ion-grid>

        <ion-item lines="none">
          <ion-button (click)="assignSpaceToMap()" size="medium" slot="end">
            {{ "SPACE_MAP.ASSIGN_SPACE" | translate }}
          </ion-button>
        </ion-item>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
